import { utilities } from '@weatherbug/common';
const { temperatureUnits, speedUnits, pressureUnits, lengthUnits } = utilities.units;

import {
    SET_UNITS,
    SET_INITIAL_UNITS
} from '../actions/unitsActions';

const initialState = {
    unitSystem: temperatureUnits.fahrenheit,
    windUnit: speedUnits.mph,
    pressureUnit: pressureUnits.inches,
    tempUnit: temperatureUnits.fahrenheit,
    rainUnit: lengthUnits.inches,
    unitsIsLoading: false,
    lastError: undefined
};

export function units(state = initialState, action) {
    switch (action.type) {
        case SET_UNITS.pending:
        {
            return {
                ...state,
                unitsIsLoading: true
            };
        }
        case SET_INITIAL_UNITS: // Set initial units just subverts the API call to set the initial values on load.
        case SET_UNITS.fulfilled:
        {
            const {
                unitSystem,
                windUnit,
                pressureUnit,
                tempUnit,
                rainUnit
            } = action.payload;

            return {
                ...state,
                unitSystem,
                windUnit,
                pressureUnit,
                tempUnit,
                rainUnit: rainUnit || state.rainUnit,
                lastError: undefined,
                unitsIsLoading: false
            };
        }
        case SET_UNITS.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                unitsIsLoading: false
            };
        }
    }

    return state;
}
